<template>
  <div class="md-layout">
    <div class="mx-auto">
      <div class="header text-center">
        <h3 class="title">{{ title }}</h3>
        <p class="category">{{ message }}</p>
        <div v-if="hasFile">
          <div class="file-input">
            <div v-if="!fileProof">
              <div class="image-container">
                <img :src="regularImg" title="" />
              </div>
            </div>
            <div class="image-container" v-else>
              <img :src="fileProof" />
            </div>
            <div class="button-container">
              <md-button
                class="md-danger md-round"
                @click="removeImage"
                v-if="fileProof"
                ><i class="fa fa-times"></i>Eliminar</md-button
              >
              <md-button class="md-primary md-round md-fileinput">
                <template v-if="!fileProof">Adjuntar</template>
                <template v-else>Cambiar</template>
                <input type="file" @change="onFileChange" />
              </md-button>
            </div>
          </div>
        </div>
        <md-button
          v-if="hasAction"
          :disabled="buttonName == 'Cargar' && !fileProof"
          class="md-layout-item md-info"
          @click.prevent="actionEvent"
        >
          {{ buttonName }}
        </md-button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import store from "../../store";
import Swal from "sweetalert2";
import Constants from "../../constants";
export default {
  props: {
    regularImg: {
      type: String,
      default: "./img/image_placeholder.jpg"
    }
  },
  data: function() {
    return {
      title: "",
      message: "",
      buttonName: "",
      hasAction: false,
      hasFile: false,
      imageRegular: "",
      fileProof: null,
      fileNameProof: "Archivo",
      fileFormProof: new FormData(),
      Constants: Constants
    };
  },
  created() {
    var purpose = this.$route.params.purpose;
    if (purpose == "clientR") {
      this.title = "¡Registro casi terminado!";
      this.message =
        "Te acabamos de enviar un correo de validación. Recuerda revisar el correo no deseado por si no llega a la bandeja de entrada.";
      this.buttonName = "Volver a enviar";
      this.hasAction = true;
    } else if (purpose == "profileR") {
      this.title = "¡Felicidades " + this.$route.params.value + "!";
      this.message = "tu perfil ha sido registrado satisfactoriamente.";
      this.buttonName = "Ver mis créditos";
      this.hasAction = true;
    } else if (purpose == "verify") {
      this.title = "¡Gracias por confirmar!";
      this.message = "Validando...";
      this.buttonName = "Volver a enviar";
      this.hasAction = false;
      axios
        .get(store.state.backend + "/verify", {
          params: {
            token: this.$route.params.value
          }
        })
        .then(response => {
          if (response.data.verified) {
            Swal.fire({
              title: "Excelente",
              text: response.data.message,
              confirmButtonClass: "md-button md-success",
              buttonsStyling: false
            });
            this.$router.push("/login/ register-profile");
          } else {
            this.hasAction = true;
            this.title = "Error al validar";
            this.message = response.data.message;
          }
        })
        .catch(e => {
          console.log(e);
        });
    } else if (purpose == "attach") {
      this.title = "Adjunta el comprobante de pago";
      this.message =
        "Una vez recibamos el archivo y lo verifiquemos con las transacciones, recibirás una notificación de confirmación";
      this.hasAction = true;
      this.hasFile = true;
      this.buttonName = "Cargar";
    }
  },
  methods: {
    actionEvent() {
      var purpose = this.$route.params.purpose;
      if (purpose == "verify") {
        axios
          .get(store.state.backend + "/user/resendRegistrationToken", {
            params: {
              token: this.$route.params.value
            }
          })
          .then(response => {
            console.log(response.data);
            if (response.data.success) {
              Swal.fire({
                title: "Token actualizado",
                text:
                  "Hemos enviado otro correo de verificación, recuerda que cuentas con 1 día para abrir el link.",
                confirmButtonClass: "md-button md-success",
                buttonsStyling: false
              });
              this.$router.push("/register-profile");
            } else {
              this.hasAction = true;
              this.title = "Error al reenviar";
              this.message = response.data.message;
            }
          })
          .catch(e => {
            console.log(e);
          });
      } else if (purpose == "profileR") {
        this.$router.push("/credit-list");
      } else if (purpose == "attach") {
        this.fileFormProof.set(
          "documentValue",
          this.Constants.getUserDocumentValue()
        );
        this.fileFormProof.set("creditId", this.$route.params.value);
        axios({
          url: store.state.backend + "/uploadProofOfPayment",
          method: "POST",
          data: this.fileFormProof,
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data"
          }
        }).then(response => {
          Swal.fire({
            title: "Comprobante cargado",
            text: "Tu documento se ha cargado satisfactoriamente.",
            confirmButtonClass: "md-button md-primary",
            buttonsStyling: false
          }).then(() => {
            this.$router.push("/credit/" + this.$route.params.value);
            this.$router.go();
          });
        });
      }
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      let reader = new FileReader();
      let vm = this;
      var partsName = file.name.split(".");
      var extension = partsName[partsName.length - 1];
      this.fileNameProof = file.name;
      if (
        extension.toLowerCase() == "jpeg" ||
        extension.toLowerCase() == "png" ||
        extension.toLowerCase() == "jpg"
      ) {
        reader.onload = e => {
          vm.fileProof = e.target.result;
          vm.fileFormProof.set(
            "file",
            file,
            "ComprobantePago " + vm.$route.params.value + "." + extension
          );
        };

        reader.readAsDataURL(file);
      } else if (file.size < 5000000) {
        reader.onload = e => {
          vm.fileProof = "./img/capital77/file-check-icon.webp";
          vm.fileFormProof.set(
            "file",
            file,
            "ComprobantePago " + vm.$route.params.value + "." + extension
          );
        };

        reader.readAsDataURL(file);
      } else {
        Swal.fire({
          title: "Tamaño no permitido",
          text: "Sólo puedes cargar un archivo menor a 5 Mb",
          timer: 2000,
          showConfirmButton: false
        });
      }
    },
    removeImage: function() {
      this.fileProof = "";
    }
  }
};
</script>
<style></style>
